/* global SideDrawer, initLazyImages */

class BaseFilters extends HTMLElement {
    constructor() {
        super();
        this.filterChangeTimeout = null;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.filteringEnabled = this.dataset.filtering === "true";
        this.sortingEnabled = this.dataset.sorting === "true";
        this.results = document.getElementById("filter-results");

        this.handleBreakpointChange();
        this.addElements();
        this.addListeners();

        BaseFilters.initGlobalListeners();
    }

    addElements() {}

    addListeners() {}

    handleBreakpointChange() {
        // if (theme.mediaMatches.lg) {
        //     this.setAttribute("open", "");
        //     this.setAttribute("aria-hidden", "false");
        //     this.removeAttribute("aria-modal");
        //     this.removeAttribute("role");
        // } else {
        //     this.close();
        //     this.setAttribute("role", "dialog");
        //     this.setAttribute("aria-modal", "true");
        //     this.setAttribute("aria-hidden", "true");
        //     this.hidden = false;
        // }
    }

    handleFilterChange(evt) {
        clearTimeout(this.filterChangeTimeout);

        this.filterChangeTimeout = setTimeout(() => {
            const searchParams = this.collectAllFilters(evt);
            this.applyFilters(searchParams.toString(), evt);
        }, 500);
    }

    handleFiltersClick(evt) {
        const { target } = evt;
        if (target.matches(".js-clear-filter")) {
            evt.preventDefault();
            this.applyFilters(
                new URL(evt.target.href).searchParams.toString(),
                evt
            );
        }
        if (target.matches(".js-show-more")) {
            const filter = target.closest(".filter");
            target.remove();
            filter
                .querySelectorAll("li")
                .forEach((el) => el.classList.remove("js-hidden"));

            if (!BaseFilters.expandedFilters.has(filter.id)) {
                BaseFilters.expandedFilters.add(filter.id);
            }
        }
    }

    handleActiveFiltersClick(evt) {
        if (evt.target.tagName !== "A") return;
        evt.preventDefault();
        this.applyFilters(
            new URL(evt.target.href).searchParams.toString(),
            evt
        );
    }

    collectAllFilters() {
        const formData = new FormData();

        // Collect data from all relevant filter forms
        const formsSet = new Set();

        if (this.form instanceof HTMLFormElement) {
            formsSet.add(this.form);
        }

        ["facets", "categories", "brands"].forEach((id) => {
            const form = document.getElementById(id);
            if (form instanceof HTMLFormElement) {
                formsSet.add(form);
            }
        });

        formsSet.forEach((form) => {
            new FormData(form).forEach((v, k) => {
                formData.append(k, v);
            });
        });

        const searchParams = new URLSearchParams(formData);

        // remove empty params
        [...searchParams.keys()].forEach((key) => {
            if (!searchParams.get(key)) searchParams.delete(key);
        });

        return searchParams;
    }

    async applyFilters(searchParams, evt, updateUrl = true) {
        await BaseFilters.applyFiltersShared({ searchParams, updateUrl });
    }

    onFiltersUpdated() {
        this.addElements();
        this.addListeners();
    }

    static initGlobalListeners() {
        if (BaseFilters._globalListenersInitialized) return;

        window.addEventListener("popstate", (evt) => {
            if (evt.state !== null && evt.state.searchParams) {
                BaseFilters.applyFiltersShared({
                    searchParams: evt.state.searchParams,
                    updateUrl: false,
                });
            }
        });

        BaseFilters._globalListenersInitialized = true;
    }

    static async applyFiltersShared({ searchParams, updateUrl }) {
        const results = document.getElementById("filter-results");
        if (!results) return;

        const customPagination = document.querySelector("custom-pagination");
        if (customPagination)
            customPagination.dataset.pauseInfiniteScroll = "true";

        if (updateUrl) BaseFilters.updateURL(searchParams);

        results.classList.add("is-loading");

        const facetsForm = document.getElementById("facets");

        let fetchUrl = `${window.location.pathname}?${searchParams}`;
        if (facetsForm?.dataset.filterSectionId) {
            fetchUrl += `&section_id=${facetsForm.dataset.filterSectionId}`;
        }

        if (BaseFilters.abortController)
            BaseFilters.abortController.abort("Request changed");
        BaseFilters.abortController = new AbortController();

        try {
            const response = await fetch(fetchUrl, {
                method: "GET",
                signal: BaseFilters.abortController.signal,
            });
            if (!response.ok) return;

            const tmpl = document.createElement("template");
            tmpl.innerHTML = await response.text();

            // Restore facets UI state (open details and "show more")
            try {
                const currentFacetsForm = document.getElementById("facets");
                if (currentFacetsForm) {
                    currentFacetsForm
                        .querySelectorAll("details-disclosure > details")
                        .forEach((existingFilter) => {
                            const target = tmpl.content.getElementById(
                                existingFilter.id
                            );
                            if (target) {
                                target.open = existingFilter.open;
                            }
                        });

                    tmpl.content
                        .querySelectorAll(
                            "#facets details-disclosure > details"
                        )
                        .forEach((newFilter) => {
                            if (BaseFilters.expandedFilters.has(newFilter.id)) {
                                const hiddenElements =
                                    newFilter.querySelectorAll(".js-hidden");
                                hiddenElements.forEach((listItem) => {
                                    listItem.classList.remove("js-hidden");
                                });
                                newFilter
                                    .querySelector(".filter__more")
                                    ?.remove();
                            }
                        });
                }
            } catch (err) {
                console.warn(err);
            }

            // Update all forms if present
            ["facets", "categories", "brands"].forEach((id) => {
                const form = document.getElementById(id);
                const newForm = tmpl.content.getElementById(id);
                if (form && newForm) {
                    form.innerHTML = newForm.innerHTML || "";
                }
            });

            // Preserve the CSS class of the results
            const currentResultsUl = results.querySelector("ul");
            if (currentResultsUl) {
                BaseFilters.currentResultsClass =
                    currentResultsUl.getAttribute("class");
            }

            // Update the results
            const newResults = tmpl.content.getElementById("filter-results");
            if (newResults) {
                results.innerHTML = newResults.innerHTML;
            }

            // Set the CSS class of the results to what it was
            const newResultsUl = results.querySelector("ul");
            if (newResultsUl && BaseFilters.currentResultsClass)
                newResultsUl.setAttribute(
                    "class",
                    BaseFilters.currentResultsClass
                );

            // Reinitialize re-rendered components for all filter elements
            document
                .querySelectorAll("category-filters, facet-filters")
                .forEach((el) => {
                    if (typeof el.onFiltersUpdated === "function") {
                        el.onFiltersUpdated();
                    }
                });

            // Reinitialize lazyload images after filters applied.
            if (typeof initLazyImages === "function") initLazyImages();

            // Reinitialize any custom pagination
            if (customPagination && customPagination.reload)
                customPagination.reload();

            // Scroll to the top of the results if needed
            if (results.getBoundingClientRect().top < 0) {
                let headerHeight = 0;
                const stickyHeader = document.querySelector(
                    'store-header[data-is-sticky="true"]'
                );
                if (stickyHeader) {
                    headerHeight =
                        Number.parseInt(
                            getComputedStyle(stickyHeader)
                                .getPropertyValue("--header-height")
                                .replace("px", ""),
                            10
                        ) || 0;
                }
                window.scrollTo({
                    top:
                        results.getBoundingClientRect().top +
                        window.scrollY -
                        headerHeight -
                        45,
                    behavior: "smooth",
                });
            }

            // Renable infinite scroll
            if (customPagination)
                customPagination.dataset.pauseInfiniteScroll = "false";

            // Broadcast the update for anything else to hook into
            document.dispatchEvent(
                new CustomEvent("on:facet-filters:updated"),
                { bubbles: true }
            );
        } catch (error) {
            console.warn(error);
        } finally {
            results.classList.remove("is-loading");
        }
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
        window.history.pushState(
            { searchParams },
            "",
            `${window.location.pathname}${
                searchParams && "?".concat(searchParams)
            }`
        );
    }
}

BaseFilters.expandedFilters = new Set();
BaseFilters.abortController = null;
BaseFilters.currentResultsClass = null;
BaseFilters._globalListenersInitialized = false;

if (!customElements.get("category-filters")) {
    class CategoryFilters extends BaseFilters {
        init() {
            super.init();
            this.scrollFiltersIntoView();
        }

        addElements() {
            if (this.filteringEnabled) {
                this.form = document.getElementById("categories");
                this.categoriesForm = this.form;
                this.categoriesFilters = document.querySelector(
                    ".categories__filters"
                );
                this.categoryFilterSlider = document.querySelector(
                    ".category__filter__content > ul"
                );
                this.activeFilters = document.querySelector(
                    ".categories__active-filters"
                );
            }
        }

        addListeners() {
            if (this.filteringEnabled) {
                this.breakpointChangeHandler =
                    this.breakpointChangeHandler ||
                    this.handleBreakpointChange.bind(this);

                if (this.categoriesFilters) {
                    this.categoriesFilters.addEventListener(
                        "click",
                        this.handleFiltersClick.bind(this)
                    );
                    this.categoriesFilters.addEventListener(
                        "input",
                        this.handleFilterChange.bind(this)
                    );
                    this.categoriesFilters.addEventListener(
                        "change",
                        this.handleFilterChange.bind(this)
                    );
                }

                if (this.activeFilters) {
                    this.activeFilters.addEventListener(
                        "click",
                        this.handleActiveFiltersClick.bind(this)
                    );
                }

                window.addEventListener(
                    "on:breakpoint-change",
                    this.breakpointChangeHandler
                );
            }
        }

        scrollFiltersIntoView() {
            const selectedCategoryFilter = document.querySelector(
                ".category__filter input:checked + label"
            );

            if (selectedCategoryFilter && this.categoryFilterSlider) {
                this.categoryFilterSlider.scrollTo({
                    top:
                        selectedCategoryFilter.offsetTop +
                        selectedCategoryFilter.offsetHeight * 2 -
                        this.categoryFilterSlider.clientHeight / 2,
                    left: 0,
                    behavior: "smooth",
                });
            }
        }

        onFiltersUpdated() {
            super.onFiltersUpdated();
            this.scrollFiltersIntoView();
        }
    }

    customElements.define("category-filters", CategoryFilters);
}

if (!customElements.get("facet-filters")) {
    class FacetFilters extends BaseFilters {
        addElements() {
            if (this.filteringEnabled) {
                this.form = document.getElementById("facets");
                this.facetsForm = this.form;
                this.facetsFilters = document.querySelector(".facets__filters");
                this.activeFilters = document.querySelector(
                    ".facets__active-filters"
                );
            }

            if (this.sortingEnabled) {
                this.mobileSortByOptions =
                    document.querySelectorAll(".js-drawer-sort-by");
                this.desktopSortBy = document.querySelector(
                    ".products-toolbar__sort"
                );
            }
        }

        addListeners() {
            if (this.filteringEnabled) {
                this.breakpointChangeHandler =
                    this.breakpointChangeHandler ||
                    this.handleBreakpointChange.bind(this);

                if (this.facetsFilters) {
                    this.facetsFilters.addEventListener(
                        "click",
                        this.handleFiltersClick.bind(this)
                    );
                    this.facetsFilters.addEventListener(
                        "input",
                        this.handleFilterChange.bind(this)
                    );
                    this.facetsFilters.addEventListener(
                        "change",
                        this.handleFilterChange.bind(this)
                    );
                }

                if (this.activeFilters) {
                    this.activeFilters.addEventListener(
                        "click",
                        this.handleActiveFiltersClick.bind(this)
                    );
                }

                window.addEventListener(
                    "on:breakpoint-change",
                    this.breakpointChangeHandler
                );
            }

            if (this.sortingEnabled && this.desktopSortBy) {
                this.desktopSortBy.addEventListener(
                    "change",
                    this.handleFilterChange.bind(this)
                );
            }
        }

        handleFilterChange(evt) {
            if (
                evt.type === "change" &&
                !(
                    evt.target.id?.includes("price-range") ||
                    evt.target.id?.includes("sort-by")
                )
            )
                return;
            if (
                evt.target.id?.includes("price-range") &&
                evt.constructor.name === "InputEvent"
            )
                return;

            clearTimeout(this.filterChangeTimeout);

            this.filterChangeTimeout = setTimeout(() => {
                const searchParams = this.collectAllFilters(evt);
                this.applyFilters(searchParams.toString(), evt);
            }, 500);
        }

        collectAllFilters(evt) {
            const searchParams = super.collectAllFilters(evt);

            if (this.sortingEnabled) {
                let currentSortBy = searchParams.get("sort_by");
                if (evt?.target?.tagName === "CUSTOM-SELECT") {
                    this.mobileSortByOptions.forEach((option) => {
                        option.checked =
                            option.value === evt.detail.selectedValue;
                        currentSortBy = evt.detail.selectedValue;
                    });
                }
                searchParams.set("sort_by", currentSortBy);
            }

            return searchParams;
        }
    }

    customElements.define("facet-filters", FacetFilters);
}
